const checkHasFilters = (
  filters: Record<string, unknown> | undefined | null
) => {
  return (
    !!filters &&
    Object.values(filters).some((filter) => {
      if (Array.isArray(filter)) {
        return filter.length > 0
      }

      return filter !== undefined
    })
  )
}

export default checkHasFilters
